import React from 'react';
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { MdOutlineWarehouse } from "react-icons/md";
import { CiBoxes } from "react-icons/ci";

export default function RoutesSummary(props: any) {
  const { summary = {} } = props;
  
  // Helper function to format currency
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  };
  
  return (
    <>
    <div className="dashboard_row">
      <div id="totalSales" className="boxIndicator">
        <h3>Resumen</h3>
        <div className="boxIndicatorContent">
          <div className="boxIndicatorContentInner">
            <h2>TOTAL ENTREGAS</h2>
            <span className="indicatorValue">{summary.total_entregas || 0}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>TOTAL VENTAS</h2>
            <span className="indicatorValue">{formatCurrency(summary.total_ventas)}</span>
          </div>
        </div>
      </div>

      <div id="totalOrders" className="boxIndicator">
        <h3>Entregas por Estado</h3>
        <div className="boxIndicatorContent">
          <div className="boxIndicatorContentInner">
            <h2>ENTREGADOS</h2>
            <span className="indicatorValue">{summary.total_entregados || 0}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>DEVUELTOS</h2>
            <span className="indicatorValue">{summary.total_devueltos || 0}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>PARCIALES</h2>
            <span className="indicatorValue">{summary.total_parciales || 0}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>%</h2>
            <span className="indicatorValue">{summary.eficiencia_entrega || 0}%</span> 
          </div>
        </div>
      </div>
    </div>
    <div className="dashboard_row">

      <div id="totalProducts" className="boxIndicator">
        <h3>Valores Monetarios</h3>
        <div className="boxIndicatorContent">
          <div className="boxIndicatorContentInner">
            <h2>ENTREGADO</h2>
            <span className="indicatorValue">{formatCurrency(summary.valor_entregado)}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>DEVUELTO</h2>
            <span className="indicatorValue">{formatCurrency(summary.valor_devuelto)}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>PARCIAL</h2>
            <span className="indicatorValue">{formatCurrency(summary.total_recaudado_parciales)}</span>
          </div>
          <div className="boxIndicatorContentInner">
            <h2>% RECAUDO</h2>
            <span className="indicatorValue">{summary.porcentaje_recaudo || 0}%</span>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
